const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const Modal = require('app/ui/Modal');

const RestaurantForm = require('app/restaurant/Form');

class CreateModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.restaurant.copy.title'),
            'restaurant': null,
            'onClose': function(event){},
            'onShown': function(event){},
            'onSuccess': function(data){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.restaurant = this.settings.restaurant;
        if(!this.restaurant){
            window.notify("Parameter restaurant is missing",'error');
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-copy-modal')
        .append(window.App.generateLoader());

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "full",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.loadData();

        this.modal.show();
    }


    loadData(){
        var self = this;

        let queries = [
            this.buildRestaurantQuery(),
            this.buildSellerQuery()
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildContent(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSellerQuery(){
        var self = this;


        let filters = {
            //'type': "agentco"
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
        };

        let fields = [
            'id',
            'user { lastName firstName }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'sellers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildRestaurantQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',

            //general form
            'siren',
            'name',
            'lastName',
            'firstName',
            'address',
            'addressComplement',
            'postalCode',
            'city',

            //billing form
            'billingStatus',
            'billingPeriods { begin end levy }',
            'seller { id }',

            //software form
            'applicationStatus',
            'analyseDisplayMode',
            'orderType',
            'orderLimit',
            'orderByMailStatus',
            'type',
            'preset',

            //contact form
            'email',
            'phone',
            'info { website linkedin twitter facebook instagram }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildContent(data){
        this.sellers = data.sellers.edges;
        this.restaurant = data.restaurant;
        this.restaurant.info = {
            'website': null,
            'linkedin': null,
            'twitter': null,
            'facebook': null,
            'instagram': null,
        };

        this.infosForm = new RestaurantForm({
            'restaurant': this.restaurant,
            'copyMode': true,
            'sellers': this.sellers,
            'success': this.settings.onSuccess,
        });

        this.$content.html('')
        .append(this.infosForm.getForm());
    }
}

module.exports = CreateModal;

